export const handleFieldValidState = (fieldName, errors) => {
    if (!errors) {
        return { isValid: true };
    }

    return errors[fieldName] !== undefined ? errors[fieldName] : { isValid: true };
};
